export const createTextbookParamFromActivity = (activity) => {
    let textbookParam = null;
    if (activity) {
        let campus = activity.campus ? activity.campus.charAt(0).toLowerCase() : undefined;
        let course = activity.courseCode ? activity.courseCode.replace(/\s/g, '-').toLowerCase() : undefined;
        let section = activity.code ? activity.code.toLowerCase() : undefined;
        let term = activity.atpId ? activity.atpId.substring(2,5) : undefined;
        let summer = activity.summerTerm ? ( ["a", "b"].includes(activity.summerTerm.replace(/-term/g, "").toLowerCase()) ? activity.summerTerm.replace(/-term/g, "").toLowerCase() : '' ) : '';
        if (campus && course && section && term) {
            textbookParam = `uw${campus}-${course}-${section}${summer}-${term}`;
        }
    }

    return textbookParam;
}